import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { useConnect } from 'redux-bundler-hook';
import Tooltip from 'root/components/molecules/Tooltip';
import getInitials from 'utils/initials';

import SkeletonLoader from './skeleton';
import { StyledBoardAvatar } from './styles';

const BoardAvatar = ({ className, onClick, showLoader, id, withTooltip }) => {
  const { boardsById } = useConnect('selectBoardsById');
  const ref = useRef(null);
  const [hover, setHover] = useState(false);

  const board = boardsById[id];

  if (showLoader || !board) {
    return (
      <StyledBoardAvatar className={className} isLoader>
        <SkeletonLoader />
      </StyledBoardAvatar>
    );
  }

  const { name, nickname } = board;
  const initials = nickname || getInitials({ maxInitials: 2, name });

  return (
    <StyledBoardAvatar
      className={className}
      colorId={id}
      count={initials.length}
      onClick={onClick}
      onMouseEnter={() => {
        if (withTooltip && name) setHover(true);
      }}
      onMouseLeave={() => {
        if (withTooltip && name) setHover(false);
      }}
      ref={ref}
    >
      {initials}
      <Tooltip active={hover} parent={ref} position="top" variant="arrow">
        {name}
      </Tooltip>
    </StyledBoardAvatar>
  );
};

BoardAvatar.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  showLoader: PropTypes.bool,
  withTooltip: PropTypes.bool,
};

BoardAvatar.defaultProps = {
  className: '',
  onClick: () => {},
  showLoader: false,
  withTooltip: false,
};

// export default connect('selectTeamsLookupWithCurrentUser', 'selectFullUser', BoardAvatar)
export default BoardAvatar;
